module.exports = __webpack_public_path__ + "static/img/DSC_0063.e6234e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_0063.jpg
// module id = zK96
// module chunks = 0